import Vue from "vue";
import Moment from "vue-moment";
import App from "./App.vue";
import Builder from "./Builder.vue";
import Dashboard from "./Dashboard.vue";
import ViewBuilder from "./views/Builder.vue";
import Preview from "./views/Preview.vue";
import Viewer from "./views/Viewer.vue";
import Strategy from "./Strategy.vue";
import User from "./User.vue";
import Activity from "./Activity.vue";
import ActivitySubmission from "./ActivitySubmission.vue";
import ActivitySubmissionLearner from "./ActivitySubmissionLearner.vue";
import ActivitySubmissionElement from "./ActivitySubmissionElement.vue";
import Submissions from "./Submissions.vue";
import BestPractices from "./BestPractices.vue";
import TeacherDashboard from "./TeacherDashboard.vue";
import Profile from "./Profile.vue";
import BasicPage from "./BasicPage";
import Notifications from "./components/Notifications.vue";
import LikeButton from "./components/Like/LikeButton.vue";
import ActivityCard from './components/ActivityCard';
import PreRequisite from './PrerequisitePage';
import NotAvailable from './NotAvailable.vue';
import router from "./router";
import VueMq from "vue-mq";
import Card from "./services/Card.custom.js";
import Datetime from "vue-datetime";

// import './registerServiceWorker'

Vue.config.productionTip = false;
Vue.use(VueMq, {
  breakpoints: {
    xsmall: 425,
    small: 770,
    medium: 959,
    large: 1279,
    xlarge: Infinity
  }
});

import {
  MdApp,
  MdRipple,
  MdButton,
  MdDatepicker,
  MdProgress,
  MdCheckbox,
  MdRadio,
  MdSteppers,
  MdIcon,
  MdList,
  MdToolbar,
  MdTooltip,
  MdDrawer,
  MdContent,
  MdCard,
  MdDialog,
  MdDialogAlert,
  MdField,
  MdDivider,
  MdMenu,
  MdSwitch,
  MdChips,
  MdAutocomplete,
  MdTabs,
  MdBottomBar,
  MdBadge,
  MdTable
} from "vue-material/dist/components";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css"; // This line here
import "vue-datetime/dist/vue-datetime.css";
import "@/assets/scss/_import.scss";
import UUID from "vue-uuid";
import Sticky from "vue-sticky-directive";
import Pagination from "vue-pagination-2";

import FbHtmlPackage from "./components/Form/FbHtmlPackage/FbHtmlPackage.vue";
import FbQuiz from "./components/Form/FbQuiz/FbQuiz.vue";
import FbScorm from "./components/Form/FbScorm/FbScorm.vue";
import FbInput from "./components/Form/FbInput.vue";
import FbTextArea from "./components/Form/FbTextArea.vue";
import FbExternalLink from "./components/Form/FbExternalLink.vue";
import FbCheckbox from "./components/Form/FbCheckbox/FbCheckbox.vue";
import FbSelect from "./components/Form/FbSelect/FbSelect.vue";
import FbTag from "./components/Form/FbTag/FbTag.vue";
import FbFile from "./components/Form/FbFile/FbFile.vue";
import FbVideo from "./components/Form/FbVideo/FbVideo.vue";
import FbControll from "./components/Form/FbControll.vue";
import FbRichText from "./components/Form/FbRichText/FbRichText.vue";
import FbRadioButton from "./components/Form/FbRadioButton/FbRadioButton.vue";
import FbLikert from "./components/Form/FbLikert/FbLikert.vue";
import FbDate from "./components/Form/FbDate.vue";
import FbParagraph from "./components/Form/FbParagraph/FbParagraph.vue";
import FbRubric from "./components/Form/FbRubric.vue";
import FbStepper from "./components/Form/FbStepper.vue";
import FbWrapper from "./components/Form/FbWrapper.vue";
import FbSlider from "./components/Form/FbSlider.vue";
import FbSliderForm from "./components/Form/FbSliderForm.vue";
import FbTemplate from "./components/Form/FbTemplate/FbTemplate.vue";
import FbDelimiter from "./components/Form/FbDelimiter.vue";
import FbCard from "./components/Form/FbCard.vue";
import FbStep from "./components/Form/FbStep.vue";
import FbLayout from "./components/Form/FbLayout.vue";
import FbInfoView from "./components/Form/FbInfoButton/FbInfoView.vue";
import FbInfoButton from "./components/Form/FbInfoButton/FbInfoButton.vue";
import FbInfoButtonTeaser from "./components/Form/FbInfoButtonTeaser/FbInfoButtonTeaser.vue";
import FbStarRating from "./components/Form/FbStarRating.vue";
import FbSubmit from "./components/Form/FbSubmit.vue";
import FbSubmitError from "./components/Form/FbSubmitError.vue";
import FbSubmitButton from "./components/Form/FbSubmitButton.vue";
import Paginate from "vuejs-paginate";
import LearnerProgress from "./LearnerProgress";

Vue.filter("token_replace", function(value, nid, type) {
  if (!value) return "";
  value = value.toString();
  if (!type) {
    return value.replace(/\[([a-z_:-]+)\]/g, (match, token) => {
      if (nid && window.drupalSettings.form_builder[nid].tokens[token]) {
        return window.drupalSettings.form_builder[nid].tokens[token];
      }
      return match;
    });
  }
  else if (type == 'quiz' || type == 'scorm') {
    return value.replace(/\[([a-z_:-]+)\]/g, (match, token) => {
      if (nid && window.drupalSettings.form_builder[nid].tokens_quiz[token]) {
        return window.drupalSettings.form_builder[nid].tokens_quiz[token];
      }
      return match;
    });
  }
  return value;
});

Vue.filter("pluralize", (word, amount) =>
  amount > 1 || amount == 0 ? `${word}s` : word
);
Vue.filter("reverse_pluralize", (word, amount) =>
  amount > 1 || amount == 0 ? word : `${word}s`
);

Vue.component("paginate", Paginate);
Vue.component("FbTag", FbTag);
Vue.component("FbSelect", FbSelect);
Vue.component("FbCheckbox", FbCheckbox);
Vue.component("FbExternalLink", FbExternalLink);
Vue.component("FbTextArea", FbTextArea);
Vue.component("FbHtmlPackage", FbHtmlPackage);
Vue.component("FbQuiz", FbQuiz);
Vue.component("FbScorm", FbScorm);
Vue.component("FbInput", FbInput);
Vue.component("FbFile", FbFile);
Vue.component("FbVideo", FbVideo);
Vue.component("FbControll", FbControll);
Vue.component("FbRadioButton", FbRadioButton);
Vue.component("FbRichText", FbRichText);
Vue.component("FbLikert", FbLikert);
Vue.component("FbDate", FbDate);
Vue.component("FbParagraph", FbParagraph);
Vue.component("FbRubric", FbRubric);
Vue.component("FbStepper", FbStepper);
Vue.component("FbWrapper", FbWrapper);
Vue.component("FbSlider", FbSlider);
Vue.component("FbSliderForm", FbSliderForm);
Vue.component("FbTemplate", FbTemplate);
Vue.component("FbDelimiter", FbDelimiter);
Vue.component("FbCard", FbCard);
Vue.component("FbStep", FbStep);
Vue.component("FbLayout", FbLayout);
Vue.component("FbInfoView", FbInfoView);
Vue.component("FbInfoButton", FbInfoButton);
Vue.component("FbInfoButtonTeaser", FbInfoButtonTeaser);
Vue.component("FbStarRating", FbStarRating);
Vue.component("pagination", Pagination);
Vue.component("ListNotifications", Notifications);
Vue.component("LikeButton", LikeButton);
Vue.component("Strategy", Strategy);
Vue.component("Activity", Activity);
Vue.component("ActivitySubmission", ActivitySubmission);
Vue.component("ActivitySubmissionLearner", ActivitySubmissionLearner);
Vue.component("ActivitySubmissionElement", ActivitySubmissionElement);
Vue.component("ActivityCard", ActivityCard);
Vue.component("Submissions", Submissions);
Vue.component("BestPractices", BestPractices);
Vue.component("TeacherDashboard", TeacherDashboard);
Vue.component("Profile", Profile);
Vue.component("Viewer", Viewer);
Vue.component("Preview", Preview);
Vue.component("ViewBuilder", ViewBuilder);
Vue.component("FbSubmit", FbSubmit);
Vue.component("FbSubmitButton", FbSubmitButton);
Vue.component("FbSubmitError", FbSubmitError);
Vue.component("BasicPage", BasicPage);
Vue.component("PreRequisite", PreRequisite);
Vue.component("NotAvailable", NotAvailable);

const STATUS = {
  ACTIVITY_NOT_STARTED: 0,
  ACTIVITY_IN_PROGRESS: 1,
  ACTIVITY_REVIEW_NEEDED: 2,
  ACTIVITY_NEEDS_WORK: 3,
  ACTIVITY_COMPLETED: 4
};

const STATUS_TEXT = [
  'Not Started', 'In Progress', 'In Review', 'Needs Work', 'Completed'
];

const SUBMISSION_TYPE = {
  SUBMISSION_TYPE_TEMP: 0,
  SUBMISSION_TYPE_MAIN: 1
};

Vue.prototype.$status = STATUS;
Vue.prototype.$status_text = STATUS_TEXT;
Vue.prototype.$submission_type = SUBMISSION_TYPE;

const ASSIGNMENT_STATUS = {
  ASSIGNMENT_NOT_STARTED: 0,
  ASSIGNMENT_REVIEW_NEEDED: 1,
  ASSIGNMENT_COMPLETED: 2
};

const ASSIGNMENT_STATUS_TEXT = [
  'Not Started', 'In Review', 'Completed'
];

Vue.prototype.$assignment_status = ASSIGNMENT_STATUS;
Vue.prototype.$assignment_status_text = ASSIGNMENT_STATUS_TEXT;

Vue.use(Moment);
Vue.use(Datetime);
Vue.use(Sticky);
Vue.use(UUID);
Vue.use(MdProgress);
Vue.use(MdApp);
Vue.use(MdBadge);
Vue.use(MdAutocomplete);
Vue.use(MdSteppers);
Vue.use(MdButton);
Vue.use(MdList);
Vue.use(MdIcon);
Vue.use(MdToolbar);
Vue.use(MdDrawer);
Vue.use(MdContent);
Vue.use(MdCard);
Vue.use(MdDialog);
Vue.use(MdDialogAlert);
Vue.use(MdField);
Vue.use(MdMenu);
Vue.use(MdCheckbox);
Vue.use(MdRadio);
Vue.use(MdDivider);
Vue.use(MdTooltip);
Vue.use(MdDatepicker);
Vue.use(MdChips);
Vue.use(MdSwitch);
Vue.use(MdTabs);
Vue.use(MdBottomBar);
Vue.use(MdRipple);
Vue.use(MdTable);

if (document.querySelector("#app")) {
  new Vue({
    router,
    render: h => h(App)
  }).$mount("#app");
}

if (document.querySelector("#dashboard")) {
  new Vue({
    router,
    render: h => h(App)
  }).$mount("#dashboard");
}

if (document.querySelector("#login")) {
  new Vue({
    router,
    render: h => h(User)
  }).$mount("#login");
}

if (document.querySelector("#basic-page")) {
  new Vue({
    router,
    render: h => h(BasicPage)
  }).$mount("#basic-page");
}

// Allow init builder with Drupal.ajax.
(function ($, window, Drupal, drupalSettings, once) {
  "use strict";

  Drupal.behaviors.catchFormBuilder = {
    attach: function (context, settings) {
      let activities = $("[data-type='form-builder']", context);
      $(once('catch_form_builder', "[data-type='form-builder']", context)).each(function() {
        let builder = $(this);
        let mode = /true/i.test(builder.attr("mode"));
        let nid = builder.attr("nid");
        let sid = builder.attr("sid");
        let noTemplate = builder.attr("data-no-template");

        new Vue({
          render: h =>
            h(Builder, {
              props: {
                mode: mode,
                nid: nid,
                sid: sid,
                noTemplate: noTemplate
              }
            })
        }).$mount(builder.get(0));
      });
    }
  }
})(jQuery, window, Drupal, drupalSettings, once);

let switch_screen = "big";
let old_screen = "big";
window.addEventListener(
  "resize",
  function() {
    if (window.innerWidth > 959) {
      switch_screen = "big";
    } else if (window.innerWidth < 959) {
      switch_screen = "small";
    }
    if (
      switch_screen == "big" &&
      (window.pageYOffset || document.documentElement.scrollTop)
    ) {
      document.querySelector("body").style.overflow = "auto";
      window.scrollTo(0, 0);
      document.querySelector("body").style.overflow = null;
    }
    if (old_screen != switch_screen) {
      setTimeout(() => {
        let height = document.querySelector(".fb-welcome")
          ? document.querySelector(".fb-welcome").offsetHeight
          : 0;

        // Ugly hack for the coach home page.
        if (drupalSettings.path.currentPath == 'coach') {
          height = 20;
        }
        document.querySelector(".md-app-scroller").style.paddingTop =
          height + "px";
      }, 300);
    }
    old_screen = switch_screen;

    // this.setTimeout(() => {
    // let toolbarHeight = document.querySelector('#toolbar-bar') ? document.querySelector('#toolbar-bar').offsetHeight : 0;
    // let adminToolbarHeight = document.querySelector('#toolbar-item-administration-tray') ? document.querySelector('#toolbar-item-administration-tray').offsetHeight : 0;
    // let viewHeight = window.innerHeight - toolbarHeight - adminToolbarHeight;
    // let appToolbarHeight = document.querySelector('.md-app-toolbar') ? document.querySelector('.md-app-toolbar').offsetHeight : 0;
    // if (document.querySelector('.md-app')) {
    //   document.querySelector('.md-app').style.height = viewHeight + "px";
    // }
    // if (document.querySelector('.md-app-scroller')) {
    //   //let height = document.querySelector('.fb-welcome') ? document.querySelector('.fb-welcome').offsetHeight : 0;
    //   //document.querySelector('.md-app-scroller').style.paddingTop = height + "px";
    //   if (window.innerWidth >= 959) {

    //     var viewportOffset = document.querySelector('.md-app-scroller').getBoundingClientRect();
    //     document.querySelector('.md-app-scroller').style.maxHeight = (window.innerHeight - viewportOffset.top) + "px";
    //   }
    //   else {
    //     document.querySelector('.md-app-scroller').style.maxHeight = null;

    //   }
    // }

    //   if (document.querySelector('.md-drawer.md-temporary.md-active')) {
    //     //document.querySelector('.md-drawer.md-temporary.md-active').style.paddingTop = toolbarHeight + adminToolbarHeight + "px";
    //   }
    // },
    // 200);
  },
  true
);

if (document.querySelector(".button-notification")) {
  document.querySelector(".button-notification").addEventListener(
    "click",
    () => {
      window.dispatchEvent(new Event("resize"));
    },
    true
  );
}

if (document.querySelector(".trigger.toolbar-item")) {
  document.querySelector(".trigger.toolbar-item").addEventListener(
    "click",
    () => {
      window.dispatchEvent(new Event("resize"));
    },
    true
  );
}

setTimeout(() => {
  window.dispatchEvent(new Event("resize"));
}, 200);

// Add focused class to radio buttons.
window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.md-radio input[type="radio"]').forEach(el => {
    el.addEventListener("focus", e => {
      e.target.closest(".md-radio-container").classList.add("focused");
    });
    el.addEventListener("blur", e => {
      e.target.closest(".md-radio-container").classList.remove("focused");
    });
  });
});
